// #region Imports
import { defineComponent, defineAsyncComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-date-edit',
    components: {
        DxDateBox: defineAsyncComponent(async () => {
            return (await import(/* webpackChunkName: "dxCommon" */ /* webpackMode: "lazy" */ 'devextreme-vue/date-box')).DxDateBox;
        }),
    },
    mixins: [appHost.mixins.form],
    props: {
        inputAttr: {
            type: Object,
            required: false,
            default: null,
        },
        valueType: {
            type: String,
            required: false,
            default: "date"
        },
        showClearButton: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    computed: {
        _valueFormat() {
            if (this.valueType === "date") {
                return {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                };
            }
            else if (this.valueType === "time") {
                return {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                };
            }
            else {
                return {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                };
            }
        },
        inputAttrInternal() {
            return this.inputAttr;
        },
    },
    methods: {
        onEnterKey(event) {
            this.$emit('EnterKey', event);
        },
    }
});
// #endregion
